import React from 'react';
//import PropTypes from 'prop-types';
import CancelView from './CancelView';
import {PickupStatus} from './PickupStatus';
import { Collapse } from 'reactstrap';
import {allowUserWithRoles, IsCordovaApp, ROLE_Driver} from "../../constants";
import {getCollectionAction, getRunFlag, getRunFlagBadgeClass, getRunFlagIcon, getRunTypeCardStyle} from "../../utils/collectionTypes";
import moment from 'moment';
import { mustBeArray } from '../../utils/lib';


class PickupLite extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isNoteView: false,
      isCancelView: false,
      cancelNoteItems: [],
      modal: false,
      images: [],
      currentImage: '',
      isOpen: false,
    };
    this.toggleIsOpen = this.toggleIsOpen.bind(this);
  }

  toggleIsOpen(evnt){
    evnt.preventDefault();
    this.setState({isOpen: !this.state.isOpen});
  }

  render() {
    let { onMapLocation, onResetRoute, run, pickup } = this.props;

    let pickupStatus = () => {
      let {badge, icon, text} = PickupStatus(pickup, run?.truckCollectionTypeCode);

      return (
        <h4>
        <span className={badge}>
      { `#${pickup.pickupOrder+1} ${pickup.locationTypeName} `} <small className="text-muted">{text}</small>
        </span>
          <span className="pull-right">&nbsp;<i className={icon} /></span>
        </h4>);
    };

    let nextPreviousView = ()=>{
      let next = pickup.isCheckOut ? null : pickup.pickupOrder + 1;
      let previous = pickup.isCheckIn ? null : pickup.pickupOrder - 1;

      let nextPickup = next == null ? null : run.pickups.filter(p => p.pickupOrder == next);
      let previousPickup = previous == null ? null : run.pickups.filter(p => p.pickupOrder == previous);

      return (
        <div className="row">
          <div className="col-md-12 col-xs-12">
            <div className="pull-left">
              <div className="input-group">
                {previousPickup &&
                <span className="input-group-btn" style={{minHeight: '35px'}}>
                <button onClick={(evnt) => onMapLocation(previousPickup[0], evnt, 'pickup')} className="btn btn-info">
                  <i className="fa fa-backward" />&nbsp;
                </button>
              </span>}
                <span className="input-group-btn" style={{minHeight: '35px'}}>
              <button onClick={(evnt) => {
                if(IsCordovaApp()){
                  window.open(`geo://0,0?q=${pickup.locationLatitude},${pickup.locationLongitude}(${encodeURI(pickup.clientCompanyName)})`, '_system', 'location=yes');
                } else {
                  window.open(`https://www.google.com/maps/dir/?api=1&destination=${pickup.locationLatitude},${pickup.locationLongitude}&travelmode=driving`, '_blank');
                }
              }} className="btn btn-info">
                <i className="fa fa-truck" />
              </button>
            </span>
              </div>
            </div>
            <div className="pull-right">
              <div className="input-group">
            <span className="input-group-btn" style={{minHeight: '35px'}}>
              <button onClick={(evnt) => onResetRoute(evnt)} className="btn btn-info">
                <i className="fa fa-th" />
              </button>
            </span>
                {nextPickup &&
                <span className="input-group-btn" style={{minHeight: '35px'}}>
              <button onClick={(evnt) => onMapLocation(nextPickup[0], evnt, 'pickup')}
                      className="btn btn-info">
              &nbsp;<i className="fa fa-forward" />
              </button>
            </span>}
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (<div className="container" style={{marginLeft: null, paddingLeft: null, paddingRight: null, ...getRunTypeCardStyle(run.truckCollectionTypeCode)}}>
      <div className="row" onClick={this.toggleIsOpen}>
        <div className="col-md-12 col-xs-12">
          { pickupStatus() }
          <span className={getRunFlagBadgeClass(run.truckCollectionTypeCode) + ' ml-1'} style={{fontSize: '75%'}}>
            <i className={getRunFlagIcon(run.truckCollectionTypeCode)}/> {getRunFlag(run.truckCollectionTypeCode)}
          </span>
          {!pickup.isBase && (
            <h6 className="text-muted">{getCollectionAction(run.truckCollectionTypeCode)} <span className="badge badge-info">{pickup.volume ? pickup.volume : 'O L'}</span> <span className="badge badge-info">{pickup.numTanks}</span><br /></h6>
          )}
          {!pickup.isBase && (
            <h6 className="text-muted">Expected <span className="badge badge-info">{pickup.expectedVolumeRaw}</span></h6>
          )}
          <h5 style={{marginTop: 10}}>{pickup.clientCompanyName}</h5>
          {pickup.locationNotes && (<h6><i className="fa fa-book" />&nbsp;&nbsp;{pickup.locationNotes}</h6>)}
        </div>
      </div>
      {this.state.isOpen &&
      <div className="row">
        <div className="col-md-12 col-xs-12">
          <i className="icon-location-pin" />&nbsp;
          {IsCordovaApp() ?
            <a href={`geo://0,0?q=${pickup.locationLatitude},${pickup.locationLongitude}(${encodeURI(pickup.clientCompanyName)})`}
               target="_system" data-rel="external">{pickup.locationFullAddress}</a>
            :
            <a href={`https://maps.google.com/maps?saddr=Current+Location&daddr=${pickup.locationLatitude},${pickup.locationLongitude}&mode=driving`}
               target="_blank">{pickup.locationFullAddress}</a>
          }
        </div>
      </div>}
      <div className="row">&nbsp;</div>
      {nextPreviousView()}
      <Collapse isOpen={this.state.isOpen}>
      <div className="row">&nbsp;</div>
      <div className="row">
        <div className="col-md-12 col-xs-12">
          <i className="icon-map" />&nbsp;
          <a href="#"
             className="card-link"
             onClick={(evnt) => onMapLocation(pickup, evnt, 'pickup')}>Show on route map</a>
        </div>
      </div>
      <div className="row">&nbsp;</div>
        {mustBeArray(pickup.locationContacts).map(x => {
          return (
            <div className="row" key={x.id}>
              <div className="col-md-12 col-xs-12"><strong><i className="fa fa-male" />&nbsp;&nbsp;</strong><span style={{marginRight: '10px'}}>{x.fullName}</span>
                {mustBeArray(x.communications).filter(y => y.communicationType.toLowerCase().includes('phone')).map(c => {
                  return (
                    <a key={c.id} href={`tel:${c.detail}`} style={{marginRight: '10px'}}><strong><i className="fa fa-phone" />&nbsp;</strong>{c.detail}</a>
                  );
                })}
              </div>
            </div>
          );
        })}
        {mustBeArray(pickup.locationCommunications).filter(y => y.communicationType.toLowerCase().includes('phone')).map(x => {
          return (
            <div className="row" key={x.id}>
              <div className="col-md-12 col-xs-12"><a href={`tel:${x.detail}`}><strong><i className="fa fa-phone" />&nbsp;&nbsp;</strong>{x.detail}</a></div>
            </div>
          );
        })}
      {pickup.locationTypeCode != 'B' && pickup.locationTypeCode != 'D' && (<div className="row">&nbsp;</div>)}

      {run.isBaseCheckedIn && <CancelView
        pickup={pickup}
        run={run}
        isReadOnly
      /> }
      {!pickup.isBase && (
        <div className="row">
          <div className="col-md-12 col-xs-12 font-weight-bold">
            Total <span className="badge badge-info">{`${parseFloat(run.totalEstimatedLitresPickedUp).toFixed(2)} L `}</span>&nbsp;from&nbsp;
    <span className="badge badge-info">{ `${run.pickupsComplete}/${run.pickupsToComplete}`}</span> locations Capacity <span className="badge badge-info">{ `${parseFloat(run.truckCapacity).toFixed(0)} L`}</span>
          </div>
        </div>
      )}
      </Collapse>
    </div>);
  }
}

export default PickupLite;
